import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultLayout from "../../layouts/DefaultLayout";
import ArticleListElement from "../../components/Articlelistelement/Articlelistelement";
import Articledetails from "../../components/Articledetails/Articledetails";
import "./Nieuwpoort.css";

const Nieuwpoort = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("bezienswaardigheden");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isSight, setIsSight] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const handleSightPopupToggle = (content = null) => {
    setIsSight(true);
    setPopupContent(content);
    setIsPopupVisible(!isPopupVisible);
  };
  const handlePopupToggle = (content = null) => {
    setIsSight(false);
    setPopupContent(content);
    setIsPopupVisible(!isPopupVisible);
  };

  const sights = [
    {
      title: t("Strand"),
      description: t("Strand description"),
      extensiveInfo: t("Strand extensiveInfo"),
      image: "assets/Images/Nieuwpoort-05.jpg",
      alttext: t("Strand"),
    },
    {
      title: t("De pier"),
      description: t("De pier description"),
      extensiveInfo: t("De pier extensiveInfo"),
      image: "assets/Images/pier.jpg",
      alttext: t("De pier"),
    },
    {
      title: t("Grote markt"),
      description: t("Grote markt description"),
      extensiveInfo: t("Grote markt extensiveInfo"),
      image: "assets/Images/GroteMarkt.jpg",
      alttext: t("Grote markt"),
    },
    {
      title: t("Jachthaven"),
      description: t("Jachthaven description"),
      extensiveInfo: t("Jachthaven extensiveInfo"),
      image: "assets/Images/Jachthaven.jpg",
      alttext: t("Jachthaven"),
    },
    {
      title: t("Havenkanaal"),
      description: t("Havenkanaal description"),
      extensiveInfo: t("Havenkanaal extensiveInfo"),
      image: "assets/Images/Geul.jpg",
      alttext: t("Havenkanaal"),
    },
    {
      title: t("Vismijn"),
      description: t("Vismijn description"),
      extensiveInfo: t("Vismijn extensiveInfo"),
      image: "assets/Images/Vismijn.jpg",
      alttext: t("Vismijn"),
    },
    {
      title: t("Albert 1 - monument"),
      description: t("Albert 1 - monument description"),
      extensiveInfo: t("Albert 1 - monument extensiveInfo"),
      image: "assets/Images/Albert1Monument.jpg",
      alttext: t("Albert 1 - monument"),
    },
    {
      title: t("De ganzepoort"),
      description: t("De ganzepoort description"),
      extensiveInfo: t("De ganzepoort extensiveInfo"),
      image: "assets/Images/Ganzepoot.jpg",
      alttext: t("De ganzepoort"),
    },
    {
      title: t("Spoorlijn 74"),
      description: t("Spoorlijn 74 description"),
      extensiveInfo: t("Spoorlijn 74 extensiveInfo"),
      image: "assets/Images/Spoorlijn74.jpg",
      alttext: t("Spoorlijn 74"),
    },
    {
      title: t("Zoektocht naar Utopia"),
      description: t("Zoektocht naar Utopia description"),
      extensiveInfo: t("Zoektocht naar Utopia extensiveInfo"),
      image: "assets/Images/Utopia.jpg",
      alttext: t("Zoektocht naar Utopia"),
    },
    {
      title: t("Natuurgebied de Ijzermonding"),
      description: t("Natuurgebied de Ijzermonding description"),
      extensiveInfo: t("Natuurgebied de Ijzermonding extensiveInfo"),
      image: "assets/Images/Ijzermonding.jpg",
      alttext: t("Natuurgebied de Ijzermonding"),
    },
  ];
  const nearby = [
    {
      title: t("Diksmuide"),
      description: t("Diksmuide description"),
      extensiveInfo: t("Diksmuide extensiveInfo"),
      image: "assets/Images/Diksmuide.jpg",
      alttext: t("Diksmuide"),
    },
    {
      title: t("Ieper"),
      description: t("Ieper description"),
      extensiveInfo: t("Ieper extensiveInfo"),
      image: "assets/Images/Ieper.jpeg",
      alttext: t("Ieper"),
    },
    {
      title: t("Poperinge"),
      description: t("Poperinge description"),
      extensiveInfo: t("Poperinge extensiveInfo"),
      image: "assets/Images/Poperinge.jpg",
      alttext: t("Poperinge"),
    },
    {
      title: t("Tyne Cot Cemetery"),
      description: t("Tyne Cot Cemetery description"),
      extensiveInfo: t("Tyne Cot Cemetery extensiveInfo"),
      image: "assets/Images/TyneCotCemetry.jpg",
      alttext: t("Tyne Cot Cemetery"),
    },
    {
      title: t("Duits Kerkhof Vladslo"),
      description: t("Duits Kerkhof Vladslo description"),
      extensiveInfo: t("Duits Kerkhof Vladslo extensiveInfo"),
      image: "assets/Images/vladslo.jpg",
      alttext: t("Duits Kerkhof Vladslo"),
    },
    {
      title: t("Hill 60"),
      description: t("Hill 60 description"),
      extensiveInfo: t("Hill 60 extensiveInfo"),
      image: "assets/Images/Hill60.jpg",
      alttext: t("Hill 60"),
    },
    {
      title: t("Brugge"),
      description: t("Brugge description"),
      extensiveInfo: t("Brugge extensiveInfo"),
      image: "assets/Images/Brugge.jpg",
      alttext: t("Brugge"),
    },
    {
      title: t("Oostende"),
      description: t("Oostende description"),
      extensiveInfo: t("Oostende extensiveInfo"),
      image: "assets/Images/Oostende.jpg",
      alttext: t("Oostende"),
    },
    {
      title: t("Koksijde"),
      description: t("Koksijde description"),
      extensiveInfo: t("Koksijde extensiveInfo"),
      image: "assets/Images/Koksijde.jpg",
      alttext: t("Koksijde"),
    },
    {
      title: t("De Panne"),
      description: t("De Panne description"),
      extensiveInfo: t("De Panne extensiveInfo"),
      image: "assets/Images/DePanne.jpg",
      alttext: t("De Panne"),
    },
  ];

  const bikeTours = [
    {
      title: t("Fiets1title"),
      description: t("Fiets1Afstand"),
      extensiveInfo: t("Fiets1Info"),
      image: "assets/Images/fiets1.jpg",
      alttext: t("Fiets1title"),
      url: "https://www.visitwestvlaanderen.be/nl/fietsroute-op-ontdekking-nieuwpoort?starting-locality=",
      gpx: "assets/GPX/Fiets1.gpx",
    },
    {
      title: t("Fiets2title"),
      description: t("Fiets2Afstand"),
      extensiveInfo: t("Fiets2Info"),
      image: "assets/Images/fiets2.jpg",
      alttext: t("Fiets2title"),
      url: "https://www.visitwestvlaanderen.be/nl/westkustfietsroute?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Fiets2.gpx",
    },
    {
      title: t("Fiets3title"),
      description: t("Fiets3Afstand"),
      extensiveInfo: t("Fiets3Info"),
      image: "assets/Images/fiets3.jpg",
      alttext: t("Fiets3title"),
      url: "https://www.visitwestvlaanderen.be/nl/cogge-geeraertfietsroute-14-18?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Fiets3.gpx",
    },
    {
      title: t("Fiets4title"),
      description: t("Fiets4Afstand"),
      extensiveInfo: t("Fiets4Info"),
      image: "assets/Images/fiets4.jpg",
      alttext: t("Fiets4title"),
      url: "https://www.visitwestvlaanderen.be/nl/met-jaek-en-nink-op-ontdekking-langs-de-ijzer?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Fiets4.gpx",
    },
    {
      title: t("Fiets5title"),
      description: t("Fiets5Afstand"),
      extensiveInfo: t("Fiets5Info"),
      image: "assets/Images/fiets5.jpg",
      alttext: t("Fiets5title"),
      url: "https://www.visitwestvlaanderen.be/nl/met-jaek-en-nink-op-ontdekking-langs-de-ijzer?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Fiets5.gpx",
    },
  ];

  const hikingTours = [
    {
      title: t("Wandel1title"),
      description: t("Wandel1Afstand"),
      extensiveInfo: t("Wandel1Info"),
      image: "assets/Images/Wandel1.jpg",
      alttext: t("Wandel1title"),
      url: "https://www.visitwestvlaanderen.be/nl/wandelroute-op-ontdekking-nieuwpoort-bad?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Wandel1.gpx",
    },
    {
      title: t("Wandel2title"),
      description: t("Wandel2Afstand"),
      extensiveInfo: t("Wandel2Info"),
      image: "assets/Images/wandel2.jpg",
      alttext: t("Wandel2title"),
      url: "https://www.visitwestvlaanderen.be/nl/stadswandelroute-nieuwpoort?starting-locality=Nieuwpoort",
      gpx: "assets/GPX/Wandel2.gpx",
    },
    {
      title: t("Wandel3title"),
      description: t("Wandel3Afstand"),
      extensiveInfo: t("Wandel3Info"),
      image: "assets/Images/wandel3.jpg",
      alttext: t("Wandel3title"),
      url: "https://www.visitwestvlaanderen.be/nl/wandelroute-op-ontdekking-westende-lombardsijde-en-nieuwpoort?starting-locality=Middelkerke",
      gpx: "assets/GPX/Wandel3.gpx",
    },
    {
      title: t("Wandel4title"),
      description: t("Wandel4Afstand"),
      extensiveInfo: t("Wandel4Info"),
      image: "assets/Images/wandel4.jpg",
      alttext: t("Wandel4title"),
      url: "https://www.visitwestvlaanderen.be/nl/ter-ydewandelroute?starting-locality=Koksijde",
      gpx: "assets/GPX/Wandel4.gpx",
    },
    {
      title: t("Wandel5title"),
      description: t("Wandel5Afstand"),
      extensiveInfo: t("Wandel5Info"),
      image: "assets/Images/wandel5.jpg",
      alttext: t("Wandel5title"),
      url: "https://www.visitwestvlaanderen.be/nl/wandelroute-op-ontdekking-oostduinkerke?starting-locality=Koksijde",
      gpx: "assets/GPX/Wandel5.gpx",
    },
  ];

  const dayTours = [
    {
      title: t("DagToch1title"),
      description: t("DagToch1Afstand"),
      extensiveInfo: t("DagToch1Info"),
      image: "assets/Images/dagtocht1.jpg",
      alttext: t("DagToch1title"),
      url: "https://www.visitwestvlaanderen.be/nl/vive-le-velo-roze?starting-locality=Diksmuide",
      gpx: "assets/GPX/Dagtoch1.gpx",
      RestoTip: t("DagToch1RestoTip"),
      ExtraTip: t("DagToch1ExtraTip"),
    },
    {
      title: t("DagToch2title"),
      description: t("DagToch2Afstand"),
      extensiveInfo: t("DagToch2Info"),
      image: "assets/Images/dagtocht2.jpg",
      alttext: t("DagToch2title"),
      gpx: "assets/GPX/Dagtoch2.gpx",
      RestoTip: t("DagToch2RestoTip"),
      ExtraTip: t("DagToch2ExtraTip"),
    },
    {
      title: t("DagToch3title"),
      description: t("DagToch3Afstand"),
      extensiveInfo: t("DagToch3Info"),
      image: "assets/Images/dagtocht3.jpg",
      alttext: t("DagToch3title"),
      gpx: "assets/GPX/Dagtoch3.gpx",
      RestoTip: t("DagToch3RestoTip"),
      ExtraTip: t("DagToch3ExtraTip"),
    },
    {
      title: t("DagToch4title"),
      description: t("DagToch4Afstand"),
      extensiveInfo: t("DagToch4Info"),
      image: "assets/Images/dagtocht4.jpg",
      alttext: t("DagToch4title"),
      gpx: "assets/GPX/Dagtoch4.gpx",
      RestoTip: t("DagToch4RestoTip"),
      ExtraTip: t("DagToch4ExtraTip"),
    },
  ];

  return (
    <DefaultLayout>
      <div className="nieuwpoort-container">
        <section id="intro">
          <h1 class="titletovisit">{t("nieuwpoortTitle")}</h1>
          <p>{t("nieuwpoortDescription")}</p>
          <p>
            {t("nieuwpoortTemporaryActivities")}{" "}
            <a
              href="https://www.nieuwpoort.be/activiteiten"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.visit-nieuwpoort.be/
            </a>
            .
          </p>
        </section>

        <nav className="tab-nav">
          <button
            className={`tab-button ${
              activeSection === "bezienswaardigheden" ? "active" : ""
            }`}
            onClick={() => setActiveSection("bezienswaardigheden")}
          >
            {t("sights")}
          </button>
          <button
            className={`tab-button ${
              activeSection === "inDeBuurt" ? "active" : ""
            }`}
            onClick={() => setActiveSection("inDeBuurt")}
          >
            {t("In de buurt")}
          </button>
          <button
            className={`tab-button ${
              activeSection === "fietstochten" ? "active" : ""
            }`}
            onClick={() => setActiveSection("fietstochten")}
          >
            {t("bikeTours")}
          </button>
          <button
            className={`tab-button ${
              activeSection === "wandeltochten" ? "active" : ""
            }`}
            onClick={() => setActiveSection("wandeltochten")}
          >
            {t("hikingTours")}
          </button>
          <button
            className={`tab-button ${
              activeSection === "dagtochten" ? "active" : ""
            }`}
            onClick={() => setActiveSection("dagtochten")}
          >
            {t("dayTours")}
          </button>
        </nav>

        {activeSection === "bezienswaardigheden" && (
          <section className="article-list-section">
            <h2 className="titletovisit">{t("sights")}</h2>
            {sights.map((sight, index) => (
              <ArticleListElement
                key={index}
                title={sight.title}
                description={sight.description}
                image={sight.image}
                alttext={sight.alttext}
                onClick={() => handleSightPopupToggle(sight)}
              />
            ))}
          </section>
        )}

        {activeSection === "inDeBuurt" && (
          <section className="article-list-section">
            <h2 className="titletovisit">{t("In de buurt")}</h2>
            {nearby.map((place, index) => (
              <ArticleListElement
                key={index}
                title={place.title}
                description={place.description}
                image={place.image}
                alttext={place.alttext}
                onClick={() => handleSightPopupToggle(place)}
              />
            ))}
          </section>
        )}

        {activeSection === "fietstochten" && (
          <section className="article-list-section">
            <h2 className="titletovisit">{t("bikeTours")}</h2>
            {bikeTours.map((tour, index) => (
              <ArticleListElement
                key={index}
                title={tour.title}
                description={tour.description}
                image={tour.image}
                alttext={tour.alttext}
                onClick={() => handlePopupToggle(tour)}
              />
            ))}
          </section>
        )}

        {activeSection === "wandeltochten" && (
          <section className="article-list-section">
            <h2 className="titletovisit">{t("hikingTours")}</h2>
            {hikingTours.map((tour, index) => (
              <ArticleListElement
                key={index}
                title={tour.title}
                description={tour.description}
                image={tour.image}
                alttext={tour.alttext}
                onClick={() => handlePopupToggle(tour)}
              />
            ))}
          </section>
        )}

        {activeSection === "dagtochten" && (
          <section className="article-list-section">
            <h2 className="titletovisit">{t("dayTours")}</h2>
            {dayTours.map((tour, index) => (
              <ArticleListElement
                key={index}
                title={tour.title}
                description={tour.description}
                image={tour.image}
                alttext={tour.alttext}
                onClick={() => handlePopupToggle(tour)}
              />
            ))}
          </section>
        )}

        {isPopupVisible && (
          <Articledetails onClose={handlePopupToggle}>
            <div>
              <h2 className="popuptitle">{popupContent.title}</h2>
              <div className="articledetails-content-param">
                <img src={popupContent.image} alt={popupContent.alttext} />
                <div>
                <p dangerouslySetInnerHTML={{ __html: popupContent.extensiveInfo }} />
                  {popupContent.RestoTip && (
                    <div>
                      <br />
                      <p><strong>Restotip:</strong> {popupContent.RestoTip}</p>
                    </div>
                  )}
                  {popupContent.ExtraTip && (
                <p dangerouslySetInnerHTML={{ __html: popupContent.ExtraTip }} />)}
                  {popupContent.url && (
                    <p className="moreInfo">
                      {t("moreInfo")}{" "}
                      <a
                        href={popupContent.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t("Klikhier")}
                      </a>
                    </p>
                  )}
                  {!isSight && (
                    <>
                      {popupContent.gpx ? (
                        <a href={popupContent.gpx} download>
                          <button className="download-button">
                            {t("downloadGPX")}
                          </button>
                        </a>
                      ) : (
                        <>
                          <button className="download-button" disabled>
                            {t("downloadGPX")}
                          </button>
                          <p className="unavailable">{t("notAvailable")}</p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </Articledetails>
        )}
      </div>
    </DefaultLayout>
  );
};

export default Nieuwpoort;
